import { render, staticRenderFns } from "./crudHours.vue?vue&type=template&id=66a454c2&scoped=true&"
import script from "./crudHours.vue?vue&type=script&lang=js&"
export * from "./crudHours.vue?vue&type=script&lang=js&"
import style0 from "./crudHours.vue?vue&type=style&index=0&id=66a454c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a454c2",
  null
  
)

export default component.exports